import { render, staticRenderFns } from "./coach_create.vue?vue&type=template&id=3759dece&"
import script from "./coach_create.vue?vue&type=script&lang=js&"
export * from "./coach_create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports